<template lang="pug">
    .menu-items.menu-items--hide
        .menu-item(v-if="content.length > 0")
            .menu-item__item(v-for="item in content" :key="item.id")
                a.menu-item__item-img-wr(:href='item.imgBigSrc' data-fancybox)
                    img.menu-item__item-img(:src="item.imgPrev.path" :alt="item.imgPrev.name" :class="{'menu-item__item-img--hide': imgHide}")
                .menu-item__item-text-wr
                    .menu-item__item-top
                        h5.menu-item__item-name {{ item.name }}
                        p.menu-item__item-description {{ item.description }}
                    .menu-item__item-block
                        .menu-item__item-block-volume {{ item.volume }}
                        .menu-item__item-block-price-wr
                            .menu-item__item-block-price-old {{ item.priceOld }}
                            .menu-item__item-block-price {{ item.price }}
                        button.menu-item__item-block-button(:class="{'menu-item__item-block-button--hide': item.availableInCart}", v-if="item.delivered", @click="addProductToCartMenu($event, item.id, 'plus')")
                          SvgIcon(name="cart2" width="32" height="28")
                        .menu-item__item-block-add-basket(:class="{'menu-item__item-block-add-basket--show': item.availableInCart}", v-if="item.delivered")
                            .menu-item__item-block-add-basket-left
                                .menu-item__item-block-add-basket-price-wr
                                    .menu-item__item-block-add-basket-price-old {{ item.priceOld }}
                                    .menu-item__item-block-add-basket-price {{ item.price }}
                                .menu-item__item-block-add-basket-volume {{ item.volume }}
                            .menu-item__item-block-counter(:class="{'menu-item__item-block-counter--hide': !item.availableInCart}", v-if="item.delivered")
                                button.menu-item__item-block-counter-button.menu-item__item-block-counter-button--dec(type="button", @click="addProductToCartMenu($event, item.id, 'minus')", :class="{'menu-item__item-block-counter-button--disabled': item.count < 1}")
                                input.menu-item__item-block-counter-input(type="number", min="1", :value="item.count || 0", @input="addProductToCartMenu($event, item.id, 'input')")
                                button.menu-item__item-block-counter-button.menu-item__item-block-counter-button--inc(type="button", @click="addProductToCartMenu($event, item.id, 'plus')")
        .menu-item-no-content(v-if="status === 'noContent' || content.length < 0")
            .menu-item-no-content-empty
            .menu-item-no-content-text
                .menu-item-no-content-title Ничего не найдено
                .page__no-content-decore-wr.page__no-content-decore-wr--1
                    img.page__no-content-decore.page__no-content-decore--1(src='@/assets/img/decor/leaf.svg' alt="decor")
                .page__no-content-decore-wr.page__no-content-decore-wr--2
                    img.page__no-content-decore.page__no-content-decore--2(src='@/assets/img/decor/cube.svg' alt="decor")
                .page__no-content-decore-wr.page__no-content-decore-wr--3
                    img.page__no-content-decore.page__no-content-decore--3(src='@/assets/img/decor/cube-scale.svg' alt="decor")
                .page__no-content-decore-wr.page__no-content-decore-wr--4
                    img.page__no-content-decore.page__no-content-decore--4(src='@/assets/img/decor/lightning.svg' alt="decor")
                .page__no-content-decore-wr.page__no-content-decore-wr--5
                    img.page__no-content-decore.page__no-content-decore--5(src='@/assets/img/decor/glow-2.svg' alt="decor")
                .page__no-content-decore-wr.page__no-content-decore-wr--6
                    img.page__no-content-decore.page__no-content-decore--6(src='@/assets/img/decor/glow-1.svg' alt="decor")
                .page__no-content-decore-wr.page__no-content-decore-wr--7
                    img.page__no-content-decore.page__no-content-decore--7(src='@/assets/img/decor/straightedge.svg' alt="decor")
                .page__no-content-decore-wr.page__no-content-decore-wr--8
                    img.page__no-content-decore.page__no-content-decore--8(src='@/assets/img/decor/straightedge.svg' alt="decor")
                .page__no-content-decore-wr.page__no-content-decore-wr--9
                    img.page__no-content-decore.page__no-content-decore--9(src='@/assets/img/decor/lightning.svg' alt="decor")
</template>

<script>
    // @ is an alias to /src
    import '@/components/common/menuItem/menuItem.styl';
    import EventBus from '@/eventBus';

    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

    export default {
        name: 'MenuItem',
        mixins: [AjaxHelpersVue],
        data() {
            return {
                imgHide: true,
            }
        },
        components: {
            SvgIcon,
        },
        props: [ 'content', 'status' ],
        created() {
            EventBus.$on('imgLoaded', (res) => {
                this.imgHide = res;
                this.$nextTick(() => {
                    this.initFancy();
                });
            });

            EventBus.$on('menuPreloaderShow', () => {
                $('.menu-items').addClass('menu-items--hide');
            });

            EventBus.$on('menuPreloaderHide', () => {
                $('.menu-items').removeClass('menu-items--hide');
            });

            this.$nextTick(() => {
                $('.page__no-content-decore--6').addClass('page__no-content-decore--hide');
                $('.page__no-content-decore--8').addClass('page__no-content-decore--hide');
                $('.page__no-content-decore--9').addClass('page__no-content-decore--hide');
                this.parallax();
            })
        },

        methods: {
            initFancy() {
                $('.menu-item__item-img-wr').fancybox({
                    // toolbar  : false,
                    btnTpl: {
                        close: '<button data-fancybox-close class="fancybox-button--close fancybox-button-close" title="{{CLOSE}}">' +
                        '<svg width="19px" height="18px" viewBox="0 0 19 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd"><g id="Мобилка/Меню-открыто" transform="translate(-338.000000, -36.000000)"><g id="Group-2" transform="translate(338.000000, 36.000000)"><rect id="Rectangle-Copy" transform="translate(9.500000, 9.000000) rotate(-45.000000) translate(-9.500000, -9.000000) " x="-2" y="8" width="23" height="2" rx="1"></rect><rect id="Rectangle-Copy" transform="translate(9.500000, 9.000000) rotate(-315.000000) translate(-9.500000, -9.000000) " x="-2" y="8" width="23" height="2" rx="1"></rect></g></g></g></svg>' +
                        '</button>',
                    },
                    baseTpl:
                    '<div class="fancybox-container" role="dialog" tabindex="-1">' +
                    '<div class="fancybox-bg"></div>' +
                    '<div class="fancybox-inner">' +
                    '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
                    '<div class="fancybox-toolbar">{{buttons}}</div>' +
                    '<div class="fancybox-stage"></div>' +
                    '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
                    '</div>'+
                    '</div>',
                    beforeClose: function () {
                        $('.fancybox-button-close').addClass('fancybox-button-close--hide');

                    }
                });
            },

            parallax() {
                $(document).on('mousemove', event => {
                    let offsetX = event.clientX,
                        offsetY = event.clientY;
                    $('.page__no-content-decore-wr--1').css('transform', `translate(${offsetX * 0.02}px, ${offsetY * -0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00005}deg)`);
                    $('.page__no-content-decore-wr--2').css('transform', `translate(${offsetX * -0.01}px, ${offsetY * 0.01}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00001}deg)`);
                    $('.page__no-content-decore-wr--3').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00005}deg)`);
                    $('.page__no-content-decore-wr--4').css('transform', `translate(${offsetX * 0.01}px, ${offsetY * 0.015}px)`).find('img').css('transform', `rotate(${offsetX * offsetY *- 0.00002}deg)`);
                    $('.page__no-content-decore-wr--5').css('transform', `translate(${offsetX * 0.02}px, ${offsetY * -0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00001}deg)`);
                    $('.page__no-content-decore-wr--6').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.01}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * -0.00002}deg)`);
                    $('.page__no-content-decore-wr--7').css('transform', `translate(${offsetX * 0.02}px, ${offsetY * -0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * -0.00005}deg)`);
                    $('.page__no-content-decore-wr--8').css('transform', `translate(${offsetX * 0.01}px, ${offsetY * -0.01}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00002}deg)`);
                    $('.page__no-content-decore-wr--9').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00001}deg)`);
                });
            },
            addProductToCartMenu(e, productId, type) {
              let $addBasket = $(e.target).parents('.menu-item__item').find('.menu-item__item-block-add-basket');
              let addBasketClass = 'menu-item__item-block-add-basket--show';
              let $addBtn = $(e.target).parents('.menu-item__item').find('.menu-item__item-block-button');
              let addBtnClass = 'menu-item__item-block-button--hide';
              let $input = $(e.target).parents('.menu-item__item').find('input');
              let count = parseInt($input.val());
              let $minusBtn = $(e.target).parents('.menu-item__item').find('.menu-item__item-block-counter-button--dec');
              let minusBtnClass = 'menu-item__item-block-counter-button--disabled';
              let $cartWidget = $('.cart-widget');
              let cartWidgetClass = 'cart-widget--active';
              let $cartWidgetCount = $('.cart-widget__count');
              let cartWidgetCountClass = 'cart-widget__count--hide';
              let $cartWidgetCountNum = $('.cart-widget__count-num');

              count = this.getAmount($input, type, 0);
              $input.val(count);

              if(count < 1 && count !== '') {
                let params = {
                  cartId: this.getCartId(),
                  productId: productId
                };

                this.removeFromCart((res) => {
                  if(this.checkProperty(this.checkProperty(res.status) && res.status === 'ok')) {
                    this.$nextTick(() => {
                      $cartWidgetCountNum.text(res.countProductsToCart);

                      if(res.countProductsToCart > 0) {
                        $cartWidget.addClass(cartWidgetClass);
                        $cartWidgetCount.removeClass(cartWidgetCountClass);
                      } else {
                        $cartWidget.removeClass(cartWidgetClass);
                        $cartWidgetCount.addClass(cartWidgetCountClass);
                      }

                      $addBasket.removeClass(addBasketClass);
                      $addBtn.removeClass(addBtnClass);

                      return false;
                    });
                  }
                }, params);
              }

              $addBasket.addClass(addBasketClass);

              this.content.forEach((el) => {
                if(el.id == productId) {
                  el["availableInCart"] = true;
                  el["count"] = count;
                }
              });

              if(count == '' || count == 0) {
                return false;
              }

              if(count < 1) {
                $minusBtn.addClass(minusBtnClass);
              } else {
                $minusBtn.removeClass(minusBtnClass);
              }

              let params = {
                cartId: this.getCartId(),
                productId: productId,
                amount: count
              };

              this.addToCart((res) => {
                if(this.checkProperty(this.checkProperty(res.status) && res.status === 'ok')) {
                  this.$nextTick(() => {
                    $cartWidgetCountNum.text(res.countProductsToCart);

                    if(res.countProductsToCart > 0) {
                      $cartWidget.addClass(cartWidgetClass);
                      $cartWidgetCount.removeClass(cartWidgetCountClass);
                    } else {
                      $cartWidget.removeClass(cartWidgetClass);
                      $cartWidgetCount.addClass(cartWidgetCountClass);
                    }
                  });
                }
              }, params);
            },
        }
    }
</script>
